import gql from "graphql-tag";
export const UPLOADmOCKUPOEDERING = gql`
  mutation updateMockupOrdering($mockups: [MockupOrdering!]) {
    updateMockupOrdering(mockups: $mockups)
  }
`;
